// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3v7bm","log":"ModalInventoryLogs_log__1i-0N","date":"ModalInventoryLogs_date__2Jxd1","userName":"ModalInventoryLogs_userName__2hPiy"};